import BaseApiController from 'controller/baseresourcecontroller';

export default class NotificationsController extends BaseApiController {
  constructor() {
    super('mvc/notifications');
  }

  async MarkAsRead(autoids) {
    return super.Post('MarkAsRead', { Items: autoids });
  }
  async GetMessages(lastreceived) {
    return super.Get(`GetMessages?lastreceived=${lastreceived}`);
  }
}
